import { twMerge } from "tailwind-merge";

import { MultiEnumFilter } from "@/features/common/components/filter/MultiEnumFilter";
import { SearchBox } from "@/features/common/components/filter/SearchBox";
import { locations } from "@/features/job/const/locations";

export const JobListFilterRow = ({ className }: { className?: string }) => {
  return (
    <div className={twMerge("flex flex-wrap space-x-2", className)}>
      <MultiEnumFilter
        label="地區"
        name="location"
        options={Object.entries(locations).map(([name, label]) => ({
          label,
          name,
        }))}
      />

      <SearchBox label="通告名稱" name="title" />
    </div>
  );
};
